// extracted by mini-css-extract-plugin
export var aaaActionsWrapper = "TestStyle-module__aaa-actions-wrapper___ond1Y";
export var base = "TestStyle-module__base___m6EIW";
export var container = "TestStyle-module__container___Nk6sC";
export var crmDataDisplay = "TestStyle-module__crm-data-display___vPm1i";
export var crmDataListButtons = "TestStyle-module__crm-data-list-buttons___n+htZ";
export var crmDataListWrapper = "TestStyle-module__crm-data-list-wrapper___7EHqh";
export var crmParamSetterContainer = "TestStyle-module__crmParamSetterContainer___YF2dr";
export var crmParamSetterInput = "TestStyle-module__crmParamSetterInput___m28Ho";
export var crmParamSetterInput2 = "TestStyle-module__crmParamSetterInput2___m8X56";
export var dataEntryValue = "TestStyle-module__data-entry-value___2A5bT";
export var dropdown = "TestStyle-module__dropdown___xUh6w";
export var forms = "TestStyle-module__forms___gL6l-";
export var generalActionsWrapper = "TestStyle-module__general-actions-wrapper___Qeear";
export var header = "TestStyle-module__header___pWseW";
export var idxboxActionsWrapper = "TestStyle-module__idxbox-actions-wrapper___R2+ib";
export var input = "TestStyle-module__input___pMmwv";
export var pcAmsActionsWrapper = "TestStyle-module__pc-ams-actions-wrapper___J1i0t";
export var pcEnrollmentActionsWrapper = "TestStyle-module__pc-enrollment-actions-wrapper___1axqf";
export var row = "TestStyle-module__row___Pr73Y";
export var testButton = "TestStyle-module__test-button___+PGSD";
export var testExtra = "TestStyle-module__test-extra___4bRA-";
export var title = "TestStyle-module__title___sCDWa";